module.exports = __webpack_public_path__ + "static/media/mr.6390ec01.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mr.svg
// module id = 2161
// module chunks = 0